import React, { Component  } from "react";
import globalVariables from "../../custom_libraries/globalVariables";
import Navigationbar from '../Navigationbar';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
        Paper, Typography, Box, Button } from '@mui/material';
import urls from '../../custom_libraries/urls';
import { get, getFreshToken } from '../../custom_libraries/serverRequests';
import { Link } from 'react-router-dom';
import { KeyboardArrowRight, KeyboardArrowLeft } from '@mui/icons-material';
import withNavigate from "../../Global_files/WithNavigate";
//-------------dark theme-------------------------------------
import { createTheme, ThemeProvider } from "@mui/material/styles"; //MUI dark theme using ThemeProvider
import CssBaseline from "@mui/material/CssBaseline";
import GppMaybeIcon from '@mui/icons-material/GppMaybe';
import SouthEastIcon from '@mui/icons-material/SouthEast';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
    //   default: "#000000",
    //   paper: "#121212",
    default: "#191e29",
      paper: "#212632", 
    },
    text: {
      primary: "#ffffff",
      secondary: "#bbbbbb",
    },
  },
});
//------------------------------------------

class DeviceActionLogs extends Component {

    constructor(props) {
        super(props);

        // Parse query params
        this.state = {
        device_id: null,
        device_name:"" ,
        logs: [],
        page: 1,
        pageSize: 10,
        totalCount: 0,
    };
    }

    componentDidMount() {
        setTimeout(() => {
        this.validateSignedIn();
        }, 0);
        // Get the device_id from the localStorage
        const deviceId = localStorage.getItem(globalVariables.DeviceActionLogs);
        const deviceName = localStorage.getItem(globalVariables.DEVICE_NAME);
        this.setState({ device_id: deviceId, device_name: deviceName });
        this.LoadActionLogsOfSelectedDevice(deviceId);
    }

    validateSignedIn = async () => {
        try {
          let is_fresh_token = await getFreshToken();
          console.log("Fresh Token:", is_fresh_token);
      
          if (!is_fresh_token) {
            console.log("Navigating to login...");
            this.props.navigate("/");
            return;
          }
        } catch (error) {
          console.error("Error in validateSignedIn:", error);
        }
      }

    LoadActionLogsOfSelectedDevice = async (deviceId, page = 1, pageSize = 10) => {
    //  this.setState({ editToggle: true });
    // console.log("--------deviceId---------", deviceId);
        try {
            let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
            // 
            let headers = {
                'content-type': 'application/json',
                'Authorization': `Bearer ${access_tocken}`
            }
            const url = urls.DEVICE_ACTION_LOGS(deviceId, page, pageSize);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
            const response = await get(url, headers); // Perform the API call using the constructed URL
            console.log(`API Response for LoadSelectedDeviceInfo ${deviceId}:`, response);
        
            if (response.results && response.results.length > 0) {
                console.log(`API Response for LoadSelectedDeviceInfo ${this.state.Selected_Device_Id}:`, response);
                this.setState({ 
                    logs:response.results,
                    totalCount: response.count || 0,
                    page,
                    pageSize,
                });
        
            } else {
                this.setState({ logs: [], totalCount: 0 });
                console.error("No valid data returned from the get-camera API");
            }
        } catch (error) {
        console.error("Error fetching cameras from API:", error);
        }
    };

    handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        this.setState({ pageSize: newSize, page: 1 }, () => {
            this.LoadActionLogsOfSelectedDevice(this.state.device_id, 1, newSize);
        });
    };

    handlePageChange = (direction) => {
        const { page, pageSize, totalCount, device_id } = this.state;
        const totalPages = Math.ceil(totalCount / pageSize);
        const newPage = page + direction;

        if (newPage < 1 || newPage > totalPages) return;

        this.setState({ page: newPage }, () => {
            this.LoadActionLogsOfSelectedDevice(device_id, newPage, pageSize);
        });
    };


    render() {
        const { logs, device_name } = this.state;
        return (
            <ThemeProvider theme={darkTheme}>
                 <CssBaseline />
                <div style={{height:'100vh', overflow:'hidden'}}>
                <Navigationbar />
                <div>
                <div style={{ display: 'flex', flexDirection: 'column', marginLeft:'3%', height:'100%' }}>
                     {/* Device ID: {this.state.device_id} */}
                    <Box
                    sx={{
                        display: 'flex',
                        marginLeft: '6.2%',
                        marginRight:'2%',
                        marginTop:'0.8%',
                        // backgroundColor: '#fafafa',
                        height:'55px',
                    }}>
                        <TableContainer component={Paper} sx={{display: 'flex', height:'100%', alignItems:"center", paddingLeft:'8px'}}>
                            <Typography sx={{fontSize:'18px', fontWeight:'600'}}>
                                <Box component="span" sx={{ color: 'grey', display: 'inline-flex', alignItems: 'center' }}>  
                                    <Link to="/aboutDevice" style={{color:'#9ccaff'}}> {device_name}</Link> 
                                    <KeyboardArrowRight /> 
                                </Box>
                                Action Logs
                            </Typography>
                        </TableContainer>
                    </Box>

                    <Box
                    sx={{
                        display: 'flex',
                        marginLeft: '6.2%',
                        marginRight:'2%',
                        marginTop:'2%',
                        // backgroundColor: '#fafafa',
                        height: 'calc(100vh - 175px)', // roughly accounts for header & pagination height
                        overflow: 'hidden',
                    }}
                    >
                        <TableContainer component={Paper}
                        sx={{
                            overflowY:'scroll',
                            minHeight: '150px',
                            // height:'100%',
                            "&::WebkitScrollbar": {
                            width: "0.2px", // Adjust scrollbar thickness
                        },
                        "&::WebkitScrollbarThumb": {
                            backgroundColor: "rgb(100, 100, 100)", // Color of the scrollbar thumb
                            borderRadius: "1px", // Rounded corners for the thumb
                        },
                        "&::WebkitScrollbarThumb:hover": {
                            backgroundColor: "#888", // Color when hovered
                        },
                        scrollbarWidth: "1px", // Adjust scrollbar thickness in Firefox
                        scrollbarColor: " #d6d6d6",
                        }}
                        >
                        <Table style={{ tableLayout: 'auto', width: '100%'}}>
                            <TableHead>
                            <TableRow sx={{backgroundColor:'#212936'}}>
                                {[
                                'Date',
                                'Action',
                                // 'Log',
                                'User',
                                
                                ].map((header) => (
                                <TableCell key={header} align="Left" sx={{borderBottom:'1px solid #a6a6a6'}}>
                                    <Typography variant="subtitle2" fontWeight="bold">
                                    {header}
                                    </Typography>
                                </TableCell>
                                ))}
                            </TableRow>
                            </TableHead>
                            <TableBody>
                                {logs && Array.isArray(logs) && logs.length > 0 &&(
                                    logs.map((log) => (
                                    <TableRow style={{ height: 30 }}>
                                        <TableCell align="left">
                                            {log.changed_at ? new Date(log.changed_at).toLocaleString() : 'N/A'}
                                        </TableCell>
                                        <TableCell align="left">
                                            {log.status !== null ? (
                                                <>
                                                {log.status.charAt(0).toUpperCase() + log.status.slice(1)}
                                                {(log.status === "mute" || log.status === "unmute") && log.camera_name && (
                                                    <span
                                                    style={{
                                                        fontStyle: "italic",
                                                        color: "#5096dc",
                                                        marginLeft: "6px"
                                                    }}
                                                    >
                                                    (Camera Name - {log.camera_name})
                                                    </span>
                                                )}
                                                {(log.status === "disarmed" || log.status === "arming" || log.status === "completed" || log.status === "failed") &&
                                                
                                                    <span
                                                        style={{
                                                            fontStyle: "italic",
                                                            color: "#5096dc",
                                                            marginLeft: "6px"
                                                        }}
                                                        >
                                                        ({log.reason})
                                                    </span>
                                                }
                                                </>
                                            ) : ( log.device_status !== null ? (
                                                <>
                                                {log.device_status.charAt(0).toUpperCase() + log.device_status.slice(1)}
                                                <span
                                                        style={{
                                                            fontStyle: "italic",
                                                            color: "#5096dc",
                                                            marginLeft: "6px"
                                                        }}
                                                        >
                                                        {log.reason && log.reason !== "null" ? `(${log.reason})` : ""}
                                                    </span>
                                                    </>
                                            ): ("N/A")
                                            )}
                                        </TableCell>
                                        {/* <TableCell>
                                            {log.reason ? log.reason : "-"}
                                        </TableCell> */}
                                        <TableCell align="left">
                                            {log.changed_by ? (log.changed_by === 'scheduler' ? 'Scheduler service' : log.changed_by) : 'N/A'}
                                        </TableCell>
                                    </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                        </TableContainer>
                        
                    </Box>
                </div>
                <Box sx={{ display: 'flex', alignItems: 'center', padding: '12px 24px', justifyContent: 'flex-end', gap:'15px'}}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <label style={{ marginRight: '10px', whiteSpace: 'nowrap', fontSize: '14px' }}>Rows per page: </label>
                                <select 
                                    value={this.state.pageSize}
                                    onChange={this.handlePageSizeChange}
                                    style={{
                                    padding: '4px 6px',
                                    fontSize: '14px',
                                    width: '60px',
                                    minWidth: 'unset',
                                    maxHeight: '30px',
                                    border: 'none',
                                    marginTop:'8px'
                                    }}
                                 >
                                    <option value={10}>10</option>
                                    <option value={25}>25</option>
                                    <option value={100}>100</option>
                                </select>
                            </Box>

                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Button onClick={() => this.handlePageChange(-1)} disabled={this.state.page === 1}>
                                   <KeyboardArrowLeft />  
                                </Button>
                                <span style={{ margin: '0 10px', fontSize: '14px' }}>Page {this.state.page}</span>
                                <Button
                                onClick={() => this.handlePageChange(1)}
                                disabled={this.state.page >= Math.ceil(this.state.totalCount / this.state.pageSize)}
                                >
                                <KeyboardArrowRight />
                                </Button>
                            </Box>
                </Box>
                </div>
                </div>
            </ThemeProvider>
        );
    }
}

export default withNavigate(DeviceActionLogs);

